import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../hooks/hooks";
import Table from "../../../../../common/components/table";
import { selectProductTypesListItems } from "../../../../../redux/product-types/selector";
import { productTypes } from "../../../../../redux/product-types/action";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../components/PageLoader";

const ManagementProductTypes = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageSize, setPageSize] = useState(10);
  const [pageData, setPageData] = useState(1)
    const itemsData = useSelector(selectProductTypesListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'Name', headerName: 'Name', sortable: true, filter: true },
          { field: 'Type', headerName: 'Type', sortable: true, filter: true },
          { field: 'CreatedOnUtc', headerName: 'CreatedOn',isDateValueFormat:true },
          { field: 'ModifiedOnUtc', headerName: 'ModifiedOn' ,isDateValueFormat:true},
        ]);
      }
      const handleAdd=()=>{
        navigate(`${0}`)
      }
      const handleEdit=(data: any)=>{
        
        navigate(`${data?.Id}`)
      }

      const fetchProductTypes=()=>{
       dispatch(productTypes.list({url:`https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/product-types/list`,entity:'productTypes',jsonData:{
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        
    
        }}))
      }
      const handleDelete=(data: any)=>{
        dispatch(productTypes.delete({
          url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/product-types/delete`,
          entity: 'productTypes',
          jsonData: {
              Records: [
                  {
                      Id: data?.Id
                  }
              ]
          }
      })).then(() => {
        dispatch(productTypes.list({url:`https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/product-types/list`,entity:'productTypes',jsonData:{
           "PageNumber": pageData,
              "PageSize": pageSize,
              "SortField": "Id",
              "SortOrder": "desc",}
          }));
      });
      }
	useEffect(() => {
        createColumnDefs()
        fetchProductTypes()
	}, [pageData,pageSize])
  const additionButtons: any = [
    {
      name: 'Add ProductType',
      callback: () => handleAdd(),
    }
  ];
	return (
    <>
    {itemsData?.isLoading ? <PageLoader />
 : 
    	<Table columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData} setPageSize={setPageSize}
      paginationData={itemsData?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons} headingName="Product Types"  />
}
      </>
    
     
	);
};

export default ManagementProductTypes;


